const API_URL = "https://app.tavad.com/hce/wp-json/wp/v2";

export async function getAllVispsicologicas() {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`${API_URL}/vispsicolog`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function getVispsicologicasByID(postId) {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`${API_URL}/vispsicolog/${postId}`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function getAllVispsicologicasByTax(taxId) {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`${API_URL}/vispsicolog?tratamiento=${taxId}&per_page=99`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
  }
}